import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], value: string, property: string): any[] {
    if (!items || !value) {
      return [];
    }

    return items.filter(item => item[property] === value);
  }
}
